// Path: ./src/App.tsx
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { HomePage } from "./app/pages/HomePage/Loadable";
import { SignInPage } from "./app/pages/SignInPage/Loadable";

import Layout from "./app/components/Layout";
import {
  ProtectedRoute,
  PublicRoute,
  RedirectRoute,
  RoleBaseAccessRoute,
} from "./app/components/ProtectedRoute";
import { InProgress } from "./app/pages/InProgress/Loadable";
import CreateTabs from "./app/pages/CreateTabsPage";
import { GoFlyerAdminContext } from "./contextApi/context";
import {
  goFlyerAdminReducer,
  setGfAdminUser,
  setUser,
} from "./contextApi/reducer";
import { initialGoFlyerAdminState } from "./contextApi/state";
import RolePage from "./app/pages/RolePage";
import AccountsPageLayout from "./app/components/AccountsPageLayout";
import UserPage from "./app/pages/UserPage";
import CreateRolePage from "./app/pages/CreateRolePage";
import "./App.css";
import CreateUserPage from "./app/pages/CreateUserPage";
import { useVerifyJWTToken } from "./utils/CheckJWT";
import LogRocket from "logrocket";
import * as amplitude from "@amplitude/analytics-browser";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/browser";
import CreateFlyer from "./app/pages/CreateFlyerItemPage";
import CreateDeals from "./app/pages/CreateDealsPage";
import CreateCoupon from "./app/pages/CreateCoupon";
import UploadFlyer from "./app/pages/UploadFlyers";
import UploadMenu from "./app/pages/UploadMenu";
import { OverviewDealTab } from "./app/pages/OverviewDealTab/Loadable";
import SaveProductDealTab from "./app/pages/SavedProductDealTab";
import CreateDealTab from "./app/pages/CreateDealTab";
import { CreateUploadFlyer } from "./app/pages/CreateUploadFlyer";
import Tags from "./app/pages/Tags";
import { LoadingProvider } from "./contextApi/LoadingContext";
import { getFinalPermission } from "./app/pages/SignInPage/getFinalPermission";
import { CircularProgress } from "@mui/material";
import MerchantPage from "./app/pages/MerchantPage";
import StorePage from "./app/pages/StorePage";
import CreateMerchantPage from "./app/pages/CreateMerchantPage";
import CreateStorePage from "./app/pages/CreateStorePage";
import NotificationPage from "./app/pages/NotificationPage";
import CreateNotificationPage from "./app/pages/CreateNotificationPage";
import CameraPage from "./app/pages/CameraPage";
import CameraUploadSuccess from "./app/pages/CameraPage/uploadSuccess";
import CreateFlyerItemListPage from "./app/pages/CreateFlyerItemListPage";
import StoreUploadedImagePage from "./app/pages/StoreUploadedImagePage";
import StoreUploadedImageList from "./app/pages/StoreUploadedImagesList";
import FlyerScraperPage from "./app/pages/FlyerScraperPage";
import { CreateFlyerScraper } from "./app/pages/CreateFlyerScraper";
import ElasticTrigger from "./app/pages/ElasticTrigger";
import FeedBack from "./app/pages/FeedBack";
import CachePage from "./app/pages/Cache";
import posthog from "posthog-js";
import UnitPage from "./app/pages/UnitPage";
import ImagesPage from "./app/pages/Images";
import CreateImagePage from "./app/pages/CreateImagePage";
import BannerPage from "./app/pages/Banner";
import CreateBannerPage from "./app/pages/CreateBannerPage";
import PreferenceCuisinePage from "./app/pages/PreferenceCuisine";
import CreatePreferenceCuisinePage from "./app/pages/CreatePreferenceCuisinePage";
import PreferenceWatchItemPage from "./app/pages/PreferenceWatchItem";
import CreatePreferenceWatchItemPage from "./app/pages/CreatePreferenceWatchItemPage";
import FigmaComponentLayout from "./app/pages/FigmaComponentLayout";
import OnBoardingPage from "./app/pages/OnBoardingPage";
import { FigmaHealthMonitorPage } from "./app/pages/figmaHealthMonitor";
import FigmaTemplateDataList from "./app/pages/FIgmaTemplateData/List-Page";
import FigmaTemplateDateCreateEdit from "./app/pages/FIgmaTemplateData/Create-Edit-Page";
import FlyerReviewPage from "./app/pages/FlyerReview";
import { adminApiService } from "./utils/api";
import {
  setPromotionTags,
  setFlyerItemCategories,
  setUnits,
} from "./contextApi/reducer";
import { SUPERADMIN } from "./utils/constant/stringConstant";
import { DataBaseDrivenVariablesPage } from "./app/pages/Database-driven-variables";
import { EmailNotificationsPage } from "./app/pages/EmailNotifications";
import ShoppingListReportPage from "./app/pages/ShoppingListReportPage";
import { AdminUserSettingsPage } from "./app/pages/AdminUserSettingsPage/Loadable";
import { AdminSettingCatalogPage } from "./app/pages/AdminSettingCatalogPage/Loadable";
import { DealSpotlightsPage } from "./app/pages/DealSpotlights/Loadable";
import { DealSpotlightEditorPage } from "./app/pages/DealSpotlights/DealSpotlightEditor/Loadable";
import RecommendationEnginePage from "./app/pages/RecommendationEngine";
import AnalyticsPage from "./app/pages/AnalyticsPage";
import { routeSegments, routes } from "./utils/constant/navigationRoutes";
import { getAuthToken } from "./utils/authTokenStorage";
import { SessionExpiredDialog } from "./app/components/SessionExpiredDialog";

function App() {
  const [state, dispatch] = React.useReducer(
    goFlyerAdminReducer,
    initialGoFlyerAdminState,
  );
  const [isVerifyingToken, setIsVerifyingToken] = useState(true);

  useEffect(() => {
    const jwtToken = getAuthToken();
    if (jwtToken === null || jwtToken === undefined) {
      dispatch(setUser(undefined));
      dispatch(setGfAdminUser(undefined));
      setIsVerifyingToken(false);
      return;
    }
    (async function () {
      const adminUser = await useVerifyJWTToken(jwtToken);
      dispatch(setGfAdminUser(adminUser));
      if (adminUser === undefined) {
        dispatch(setUser(undefined));
      } else {
        const rawRoles = adminUser.roles?.[0];
        const finalPermission = getFinalPermission(rawRoles);
        dispatch(
          setUser({
            ...adminUser,
            message: "", //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) bad, need to come back
            token: jwtToken, //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) bad, need to come back
            parsedRoles: {
              name: rawRoles?.name,
              permissions: finalPermission,
            },
            userName: adminUser.userName,
            isLoggedIn: true,
            jwtToken: jwtToken,
          }),
        );
      }
      setIsVerifyingToken(false);
    })();
  }, []);

  useEffect(() => {
    if (!state.user) {
      return;
    }

    if (!state.promotionTags) {
      (async () => {
        try {
          const result =
            await adminApiService.getManyBaseGfPromotionTagAdminControllerGfPromotionTag();
          dispatch(setPromotionTags(result.data));
        } catch (error) {
          console.error("Error initializing promotion tags:", error);
        }
      })();
    }

    if (!state.units) {
      (async () => {
        try {
          const result =
            await adminApiService.getManyBaseGfUnitAdminControllerGfUnit();
          dispatch(setUnits(result.data));
        } catch (error) {
          console.error("Error initializing units:", error);
        }
      })();
    }

    if (!state.flyerItemCategories) {
      if (
        state.user.parsedRoles?.name === SUPERADMIN ||
        state.user.merchant?.length === 0
      ) {
        // For admins and superadmins, fetch all categories
        (async () => {
          try {
            const result =
              await adminApiService.getManyBaseGfFlyerItemCategoryAdminControllerGfFlyerItemCategory();
            dispatch(setFlyerItemCategories(result.data));
          } catch (error) {
            console.error("Error initializing flyer item categories:", error);
          }
        })();
      } else if (
        state.user.gfFlyerItemCategory &&
        state.user.gfFlyerItemCategory.length > 0
      ) {
        // For department managers, use user's assigned categories
        dispatch(setFlyerItemCategories(state.user.gfFlyerItemCategory));
      }
    }
  }, [state.user, state.promotionTags, state.units, state.flyerItemCategories]);

  useEffect(() => {
    if (process.env.REACT_APP_IS_DEV === `false`) {
      try {
        if (!process.env.REACT_APP_LOGROCKET) {
          throw new Error("Missing REACT_APP_LOGROCKET");
        }

        LogRocket.init(process.env.REACT_APP_LOGROCKET);
        amplitude.init("64e4b1aabad4994faf9a267ad009ae95");
        Sentry.init({
          dsn: "https://fb0644b5109f4d3da88f3b5b35090aab@o4504323284467712.ingest.sentry.io/4504323287613440",
          integrations: [new BrowserTracing(), new Sentry.Replay()],
          /**
           * add this because we didn't pay sentry. we want to see if error is still happening. Now, it stop capturing error due to usage limit
           */
          sampleRate: 0.1,
          // Set tracesSampleRate to 1.0 to capture 100%
          // of transactions for performance monitoring.
          // We recommend adjusting this value in production
          tracesSampleRate: 0.3,
          // This sets the sample rate to be 10%. You may want this to be 100% while
          // in development and sample at a lower rate in production
          replaysSessionSampleRate: 0.1,
          // If the entire session is not sampled, use the below sample rate to sample
          // sessions when an error occurs.
          replaysOnErrorSampleRate: 1.0,
        });

        try {
          if (process.env.REACT_APP_POSTHOG_API_KEY) {
            posthog.init(process.env.REACT_APP_POSTHOG_API_KEY, {
              api_host: "https://us.i.posthog.com",
              person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
              session_recording: {
                maskAllInputs: false,
                maskInputOptions: {
                  password: true, // Highly recommended as a minimum!!
                  // color: false,
                  // date: false,
                  // 'datetime-local': false,
                  // email: false,
                  // month: false,
                  // number: false,
                  // range: false,
                  // search: false,
                  // tel: false,
                  // text: false,
                  // time: false,
                  // url: false,
                  // week: false,
                  // textarea: false,
                  // select: false,
                },
              },
            });
          }
        } catch (error) {
          console.error("PostHog initialization error:", error);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, []);

  useEffect(() => {
    const handleTouchMove = (event: TouchEvent) => {
      const scale = (event as TouchEvent & { scale?: number }).scale;
      if (scale !== undefined && scale !== 1) {
        event.preventDefault();
      }
    };

    try {
      document.addEventListener("touchmove", handleTouchMove, {
        passive: false,
      });
    } catch (error) {
      // Safari throws SecurityError when non-passive touch listeners conflict
      // with viewport zoom restrictions; viewport meta already disables zoom.
      console.warn("Unable to register touchmove listener:", error);
      return;
    }

    return () => {
      document.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  const isSelfRegisterAdminFree =
    state?.gfAdminUser?.roles?.[0]?.name === "Self Register Admin Free";
  const hasNoStores =
    Array.isArray(state?.gfAdminUser?.stores) &&
    state?.gfAdminUser?.stores?.length === 0;
  const hasNoMerchants =
    Array.isArray(state?.gfAdminUser?.merchant) &&
    state?.gfAdminUser?.merchant?.length === 0;
  const showOnBoarding =
    isSelfRegisterAdminFree &&
    hasNoStores &&
    hasNoMerchants &&
    state.user?.isLoggedIn;

  if (isVerifyingToken) {
    return (
      <CircularProgress
        sx={{ color: "#ff813a" }}
        size={200}
        data-testid="app-test-id"
      />
    );
  }

  if (showOnBoarding) {
    return (
      <GoFlyerAdminContext.Provider value={{ state, dispatch }}>
        <LoadingProvider>
          <SessionExpiredDialog />
          <Router>
            <Layout>
              <OnBoardingPage />
            </Layout>
          </Router>
        </LoadingProvider>
      </GoFlyerAdminContext.Provider>
    );
  }

  return (
    <GoFlyerAdminContext.Provider
      value={{ state, dispatch }}
      data-testid="app-test-id"
    >
      <LoadingProvider>
        <SessionExpiredDialog />
        <Router>
          <Layout>
            <Routes>
              <Route element={<PublicRoute />}>
                <Route path={routes.core.root} element={<SignInPage />} />

                <Route path={routes.core.login} element={<SignInPage />} />
                <Route path={routes.core.signup} element={<SignInPage />} />
              </Route>
              <Route path={routes.camera.pattern} element={<CameraPage />} />

              <Route
                path={routes.camera.success}
                element={<CameraUploadSuccess />}
              />
              <Route element={<ProtectedRoute />}>
                <Route path={routes.core.dashboard} element={<HomePage />} />
                <Route path={routes.core.createTabs} element={<CreateTabs />} />
                <Route path={routes.core.wildcard} element={<InProgress />} />
                <Route
                  path={routes.storeUploadImage.base}
                  element={
                    <CreateTabs>
                      <StoreUploadedImagePage />
                    </CreateTabs>
                  }
                />
                <Route
                  path={routes.storeUploadImage.pattern}
                  element={
                    <CreateTabs>
                      <StoreUploadedImageList />
                    </CreateTabs>
                  }
                />
              </Route>

              <Route
                path={routes.createFlyer.base}
                element={
                  <>
                    <RoleBaseAccessRoute groupName="Flyer" roleName="view" />
                    <CreateTabs>
                      {" "}
                      <CreateFlyerItemListPage />
                    </CreateTabs>
                  </>
                }
              ></Route>
              <Route
                path={routes.createFlyer.pattern}
                element={
                  <>
                    <RoleBaseAccessRoute groupName="Flyer" roleName="view" />
                    <CreateTabs>
                      {" "}
                      <CreateFlyer />
                    </CreateTabs>
                  </>
                }
              ></Route>
              <Route
                path={routes.createDeal.base}
                element={
                  <>
                    <RoleBaseAccessRoute groupName="Deals" roleName="view" />
                    <RedirectRoute
                      parentRoute={routes.createDeal.base}
                      redirectTo={routes.core.viewRedirect}
                    />
                  </>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={
                    <CreateTabs>
                      {" "}
                      <CreateDeals>
                        <OverviewDealTab />
                      </CreateDeals>
                    </CreateTabs>
                  }
                />
                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="Deals"
                        roleName="create"
                      />
                      <CreateTabs>
                        {" "}
                        <CreateDeals>
                          <CreateDealTab />
                        </CreateDeals>
                      </CreateTabs>
                    </>
                  }
                />
                <Route
                  path={routeSegments.edit.createDeal}
                  element={
                    <>
                      <RoleBaseAccessRoute groupName="Deals" roleName="edit" />
                      <CreateTabs>
                        {" "}
                        <CreateDeals>
                          <CreateDealTab />
                        </CreateDeals>
                      </CreateTabs>
                    </>
                  }
                />
                <Route
                  path={routeSegments.previousDeal}
                  element={
                    <CreateTabs>
                      {" "}
                      <CreateDeals>
                        <SaveProductDealTab />
                      </CreateDeals>
                    </CreateTabs>
                  }
                />
              </Route>
              <Route
                path={routes.createCoupon.base}
                element={
                  <>
                    <RoleBaseAccessRoute groupName="Coupon" roleName="view" />
                    <CreateTabs>
                      {" "}
                      <CreateCoupon />
                    </CreateTabs>
                  </>
                }
              ></Route>
              <Route
                path={routes.uploadFlyer.base}
                element={
                  <>
                    <RoleBaseAccessRoute groupName="Upload" roleName="flyer" />
                    <RedirectRoute
                      parentRoute={routes.uploadFlyer.base}
                      redirectTo={routes.core.viewRedirect}
                    />
                  </>
                }
              >
                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="Upload"
                        roleName="flyer" //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) flyer? shouldn't be edit/create/view?
                      />
                      <CreateTabs>
                        <CreateUploadFlyer />
                      </CreateTabs>
                    </>
                  }
                ></Route>
                <Route
                  path={routeSegments.edit.uploadFlyer}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="Upload"
                        roleName="flyer" //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) need to change this
                      />
                      <CreateTabs>
                        <CreateUploadFlyer />
                      </CreateTabs>
                    </>
                  }
                ></Route>
                <Route
                  path={routeSegments.view}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="Upload"
                        roleName="flyer"
                      />

                      <CreateTabs>
                        {" "}
                        <UploadFlyer />
                      </CreateTabs>
                    </>
                  }
                ></Route>
                <Route
                  path={routeSegments.wildcard}
                  element={<Navigate to={routes.uploadFlyer.base} replace />}
                ></Route>
              </Route>
              <Route
                path={routes.adminFlyerReview.pattern}
                element={
                  <>
                    <RoleBaseAccessRoute groupName="Upload" roleName="flyer" />
                    <CreateTabs>
                      <FlyerReviewPage />
                    </CreateTabs>
                  </>
                }
              ></Route>
              <Route
                path={routes.uploadMenu.base}
                element={
                  <>
                    <RoleBaseAccessRoute groupName="Upload" roleName="menu" />
                    <CreateTabs>
                      {" "}
                      <UploadMenu />
                    </CreateTabs>
                  </>
                }
              ></Route>

              <Route
                path={routes.user.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="User" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<UserPage />} />
              </Route>
              <Route
                path={routes.user.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="User" roleName="create" />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.create}
                  element={<CreateUserPage />}
                />
                <Route
                  path={routeSegments.edit.user}
                  element={<CreateUserPage />}
                />
              </Route>
              <Route
                path={routes.merchant.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="Merchant" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<MerchantPage />} />

                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="Merchant"
                        roleName="create"
                      />
                      <CreateMerchantPage />
                    </>
                  }
                />
                <Route
                  path={routeSegments.edit.merchant}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="Merchant"
                        roleName="edit"
                      />
                      <CreateMerchantPage />
                    </>
                  }
                />
              </Route>

              <Route
                path={routes.store.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="Store" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<StorePage />} />
                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="Store"
                        roleName="create"
                      />
                      <CreateStorePage />
                    </>
                  }
                />
                <Route
                  path={routeSegments.edit.store}
                  element={
                    <>
                      <RoleBaseAccessRoute groupName="Store" roleName="edit" />
                      <CreateStorePage />
                    </>
                  }
                />
              </Route>

              <Route
                path={routes.role.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="Role" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<RolePage />} />
                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute groupName="Role" roleName="create" />
                      <CreateRolePage />
                    </>
                  }
                />
                <Route
                  path={routeSegments.edit.role}
                  element={
                    <>
                      <RoleBaseAccessRoute groupName="Role" roleName="edit" />
                      <CreateRolePage />
                    </>
                  }
                />
              </Route>

              <Route
                path={routes.permission.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="User" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<InProgress />} />
              </Route>
              <Route
                path={routes.tag.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="Tag" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<Tags />} />
              </Route>
              <Route
                path={routes.dealSpotlights.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="deals" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<DealSpotlightsPage />}
                />
                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="deals"
                        roleName="create"
                      />
                      <DealSpotlightEditorPage />
                    </>
                  }
                />
                <Route
                  path={routeSegments.edit.dealSpotlight}
                  element={
                    <>
                      <RoleBaseAccessRoute groupName="deals" roleName="edit" />
                      <DealSpotlightEditorPage />
                    </>
                  }
                />
              </Route>
              <Route
                path={routes.notification.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="Notification"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<NotificationPage />}
                />
              </Route>
              <Route
                path={routes.notification.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="Notification"
                      roleName="create"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.create}
                  element={<CreateNotificationPage />}
                />
              </Route>
              <Route
                path={routes.flyerScraper.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="FlyerScraper"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<FlyerScraperPage />}
                />
                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="FlyerScraper"
                        roleName="create"
                      />
                      <CreateFlyerScraper />
                    </>
                  }
                />
                <Route
                  path={routeSegments.edit.flyerScraper}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="FlyerScraper"
                        roleName="edit"
                      />
                      <CreateFlyerScraper />
                    </>
                  }
                />
              </Route>

              <Route
                path={routes.elasticTrigger.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="ElasticTrigger"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<ElasticTrigger />} />
              </Route>
              <Route
                path={routes.feedback.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="Feedback" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<FeedBack />} />
              </Route>
              <Route
                path={routes.unit.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="Unit" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<UnitPage />} />
              </Route>
              <Route
                path={routes.cache.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="Cache" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<CachePage />} />
              </Route>
              <Route
                path={routes.image.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="Image" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<ImagesPage />} />

                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="Image"
                        roleName="create"
                      />
                      <CreateImagePage />
                    </>
                  }
                />
                <Route
                  path={routeSegments.edit.image}
                  element={
                    <>
                      <RoleBaseAccessRoute groupName="Image" roleName="edit" />
                      <CreateImagePage />
                    </>
                  }
                />
              </Route>

              <Route
                path={routes.banner.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="banner" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<BannerPage />} />

                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="banner"
                        roleName="create"
                      />
                      <CreateBannerPage />
                    </>
                  }
                />
                <Route
                  path={routeSegments.edit.banner}
                  element={
                    <>
                      <RoleBaseAccessRoute groupName="banner" roleName="edit" />
                      <CreateBannerPage />
                    </>
                  }
                />
              </Route>

              {/* Cuisine vocabulary for customer onboarding preferences.
                  `/admin-preference-cuisine` is guarded by the tag permission
                  group, so the routes are gated on "tag" rather than a new one. */}
              <Route
                path={routes.preferenceCuisine.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="tag" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<PreferenceCuisinePage />}
                />

                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute groupName="tag" roleName="create" />
                      <CreatePreferenceCuisinePage />
                    </>
                  }
                />
                <Route
                  path={routeSegments.edit.preferenceCuisine}
                  element={
                    <>
                      <RoleBaseAccessRoute groupName="tag" roleName="edit" />
                      <CreatePreferenceCuisinePage />
                    </>
                  }
                />
              </Route>

              {/* Watch items are shared vocabulary (no customer relation since
                  the resource was reshaped), so they are gated on "tag" like the
                  cuisine screens rather than on the customer group. */}
              <Route
                path={routes.preferenceWatchItem.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute groupName="tag" roleName="view" />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<PreferenceWatchItemPage />}
                />

                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute groupName="tag" roleName="create" />
                      <CreatePreferenceWatchItemPage />
                    </>
                  }
                />
                <Route
                  path={routeSegments.edit.preferenceWatchItem}
                  element={
                    <>
                      <RoleBaseAccessRoute groupName="tag" roleName="edit" />
                      <CreatePreferenceWatchItemPage />
                    </>
                  }
                />
              </Route>
              <Route
                path={routes.figma.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="figmaComponentLayout"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<FigmaComponentLayout />}
                />
              </Route>

              <Route
                path={routes.figmaHealthMonitor.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="figmaHealthMonitoring"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<FigmaHealthMonitorPage />}
                />
              </Route>

              <Route
                path={routes.figmaTemplate.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="figmaTemplates"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<FigmaTemplateDataList />}
                />

                <Route
                  path={routeSegments.create}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="figmaTemplates"
                        roleName="create"
                      />
                      <FigmaTemplateDateCreateEdit />
                    </>
                  }
                />
                <Route
                  path={routeSegments.edit.figmaTemplate}
                  element={
                    <>
                      <RoleBaseAccessRoute
                        groupName="figmaTemplates"
                        roleName="edit"
                      />
                      <FigmaTemplateDateCreateEdit />
                    </>
                  }
                />
              </Route>
              <Route
                path={routes.variables.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="variables"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<DataBaseDrivenVariablesPage />}
                />
              </Route>
              <Route
                path={routes.emailNotifications.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="variables"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<EmailNotificationsPage />}
                />
              </Route>
              <Route
                path={routes.shoppingListReport.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="shoppingListReport"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<ShoppingListReportPage />}
                />
              </Route>
              <Route path="/adminUserSettings" element={<ProtectedRoute />}>
                <Route path="view" element={<AdminUserSettingsPage />} />
              </Route>
              <Route
                path={routes.recommendationEngine.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="recommendationEngine"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route
                  path={routeSegments.view}
                  element={<RecommendationEnginePage />}
                />
              </Route>
              <Route
                path={routes.analytics.base}
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="analytics"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route path={routeSegments.view} element={<AnalyticsPage />} />
              </Route>
              <Route
                path="/adminSettingCatalog"
                element={
                  <AccountsPageLayout>
                    <RoleBaseAccessRoute
                      groupName="adminSettingCatalog"
                      roleName="view"
                    />
                  </AccountsPageLayout>
                }
              >
                <Route path="view" element={<AdminSettingCatalogPage />} />
              </Route>
            </Routes>
          </Layout>
        </Router>
      </LoadingProvider>
    </GoFlyerAdminContext.Provider>
  );
}

export default App;
